module.exports = __webpack_public_path__ + "img/antes_despues_06.962b90bc.png";